module.exports = __webpack_public_path__ + "static/media/ten_percent_discount.258109d9.svg";